module.exports = __webpack_public_path__ + "95c0259ac.jpg";